/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Inactive_HintInputs */



/**
* | output |
* | --- |
* | "No new signups can use this code. Existing customers keep earning." |
*
* @param {Partner_Referral_Inactive_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_inactive_hint = /** @type {((inputs?: Partner_Referral_Inactive_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Inactive_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Registrierungen können diesen Code nicht nutzen. Bestehende Kunden verdienen weiter.")
	return /** @type {LocalizedString} */ ("No new signups can use this code. Existing customers keep earning.")
});